import { Component, inject, OnInit } from '@angular/core';
import { FADEIN_OUT_ANIMATION } from '../../../shared/constants/animations';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
    // animations: FADEIN_OUT_ANIMATION,
    selector: 'app-support',
    imports: [],
    templateUrl: './support.component.html',
    styleUrl: './support.component.scss'
})
export class SupportComponent implements OnInit {

  private meta = inject(Meta);
  private title = inject(Title);

  ngOnInit(): void {
    this.setUpSEOTags();
  }

  private setUpSEOTags() {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = 'pages/about-us/support'
    const component = 'Local Food System'
    const title = `${component} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }

}
